/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Set_Country_PromptInputs */



/**
* | output |
* | --- |
* | "Set your country in your profile to see local community." |
*
* @param {Community_Set_Country_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_set_country_prompt = /** @type {((inputs?: Community_Set_Country_PromptInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Set_Country_PromptInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Définissez votre pays dans votre profil pour voir la communauté locale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establece tu país en tu perfil para ver la comunidad local.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Defina seu país no seu perfil para ver a comunidade local.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta il tuo paese nel profilo per vedere la comunità locale.")
	return /** @type {LocalizedString} */ ("Set your country in your profile to see local community.")
});